import React from 'react';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import PetOwners from "../../components/patients/modals/PetOwners";
import Pets from "../../components/patients/modals/Pets";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PetOwnerForm from '../../components/patients/forms/PetOwnerForm';
import PetOwnerView from '../../components/patients/modals/PetOwnerView';
import { getPetOwnerById } from '../../api/petOwnerService';
import QrCode from '../../components/patients/modals/QrCode';
import RequirePermission from '../../components/RequirePermission';
import { SUB_MODULES } from '../../constants/subModulesConstants';

const PatientsPage = () => {

    const [petOwnerFormOpen, setPetOwnerFormOpen] = React.useState(false);
    const [petFormMode, setPetFormMode] = React.useState('create');
    const [selectedPetOwner, setSelectedPetOwner] = React.useState(null);
    const [petOwnerViewOpen, setPetOwnerViewOpen] = React.useState(false);

    const handleAdd = () => {
        setSelectedPetOwner(null);
        setPetFormMode("create");
        setPetOwnerFormOpen(true);
    };

    const handleEdit = () => {
        setPetFormMode("edit");
        setPetOwnerFormOpen(true);
    };

    const onSavePetOwnerSuccess = async (savedPetOwner) => {
        const updatedPetOwner = await getPetOwnerById(savedPetOwner.id);
        setSelectedPetOwner(updatedPetOwner);
        if (!petOwnerViewOpen) setPetOwnerViewOpen(true);
    };

    return (
        <>
            <Typography variant="h4">Patients</Typography>
            <List>
                <RequirePermission
                  subModuleName={SUB_MODULES.QR_CODE}
                  minAccessLevel={2}
                >
                  <QrCode />
                </RequirePermission>
                <RequirePermission
                  subModuleName={SUB_MODULES.PET_OWNERS}
                  minAccessLevel={2}
                >
                  <ListItem>
                      <ListItemButton onClick={handleAdd}>
                      <ListItemIcon>
                          <PersonAddAlt1Icon fontSize='large' color='secondary' />
                      </ListItemIcon>
                      <ListItemText 
                          primary="New Patient"
                          secondary="create new pet owner and pet(s) record"
                      />
                      </ListItemButton>
                  </ListItem>
                </RequirePermission>
                <RequirePermission
                  subModuleName={SUB_MODULES.PETS}
                  minAccessLevel={1}
                >
                  <Pets />
                </RequirePermission>
                <RequirePermission
                  subModuleName={SUB_MODULES.PET_OWNERS}
                  minAccessLevel={1}
                >
                  <PetOwners />
                </RequirePermission>
            </List>
            <PetOwnerView 
                handleEdit={handleEdit}
                setPetOwners={null}
                petOwner={selectedPetOwner}
                open={petOwnerViewOpen}
                onClose={() => setPetOwnerViewOpen(false)}
            />
            <PetOwnerForm 
                successCallback={onSavePetOwnerSuccess}
                setPetOwners={null} 
                petOwner={selectedPetOwner}
                mode={petFormMode}
                open={petOwnerFormOpen}
                onClose={() => setPetOwnerFormOpen(false)}
            />
        </>
    );
};

export default PatientsPage;
